import React, { Component } from 'react';
import PropTypes from 'prop-types';

class DashboardSummaryErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('DashboardSummary Error:', error, errorInfo);
    this.setState({
      error: error?.toString() || 'Unknown error',
      errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // Silently fail - hide the summary feature but let the dashboard work normally
      console.error('DashboardSummary hidden due to error:', this.state.error);
      return null;
    }

    return this.props.children;
  }
}

DashboardSummaryErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  onReset: PropTypes.func
};

export default DashboardSummaryErrorBoundary;
